// extracted by mini-css-extract-plugin
export default {"articleLetter":"Letter_articleLetter__Jw3gL","letterWrapper":"Letter_letterWrapper__mQOPi"};